import React from "react";
import { useParams } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useMediaQuery } from "@material-ui/core";

import TicketsManagerTabs from "../../components/TicketsManagerTabs";
import Ticket from "../../components/Ticket";
import { QueueSelectedProvider } from "../../context/QueuesSelected/QueuesSelectedContext";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
	chatContainer: {
		flex: 1,
		padding: theme.padding,
		height: `calc(100% - 48px)`,
		overflowY: "hidden",
		'@media (max-width: 1366px)': {
			padding: theme.spacing(1),
		},
		[theme.breakpoints.down("sm")]: {
			padding: 0,
		},
	},

	chatPapper: {
		display: "flex",
		height: "100%",
	},

	contactsWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
		overflowY: "hidden",
		borderRight: theme.mode === "dark"
			? "1px solid rgba(91,45,142,0.12)"
			: "1px solid rgba(91,45,142,0.15)",
	},
	messagessWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
	},
	welcomeMsg: {
		background: theme.mode === "dark"
			? "rgba(11,15,26,0.60)"
			: "#f8fafc",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		height: "100%",
		textAlign: "center",
		flexDirection: "column",
		gap: "16px",
	},
	logo: {
		logo: theme.logo,
	},
}));

const Chat = () => {
	const classes = useStyles();
	const { ticketId } = useParams();
	const theme = useTheme();
	const isMobile = useMediaQuery("(max-width:500px)");

	// En móvil: si hay ticket abierto muestra solo el chat, si no muestra solo la lista
	const showList = !isMobile || !ticketId;
	const showChat = !isMobile || !!ticketId;

	return (
		<QueueSelectedProvider>
		<div className={classes.chatContainer}>
			<div className={classes.chatPapper}>
				<Grid container spacing={0} style={{ height: "100%" }}>
					{showList && (
						<Grid
							item
							xs={12}
							sm={4}
							className={classes.contactsWrapper}
							style={isMobile ? { width: "100%" } : {}}
						>
							<TicketsManagerTabs />
						</Grid>
					)}
					{showChat && (
						<Grid
							item
							xs={12}
							sm={8}
							className={classes.messagessWrapper}
							style={isMobile ? { width: "100%" } : {}}
						>
							{ticketId ? (
								<Ticket />
							) : (
								<Paper square variant="outlined" className={classes.welcomeMsg}>
									<div style={{
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										gap: 16,
										opacity: 0.6
									}}>
										<div style={{
											width: 64, height: 64,
											borderRadius: "50%",
											background: "rgba(91,45,142,0.10)",
											border: "1px solid rgba(91,45,142,0.20)",
											display: "flex", alignItems: "center", justifyContent: "center",
										}}>
											<span style={{ fontSize: 28 }}>💬</span>
										</div>
										<span style={{
											fontSize: 14,
											color: "inherit",
											fontWeight: 500,
										}}>
											{i18n.t("chat.noTicketMessage")}
										</span>
									</div>
								</Paper>
							)}
						</Grid>
					)}
				</Grid>
			</div>
		</div>
		</QueueSelectedProvider>
	);
};

export default Chat;
